import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { presentFormatedData } from '../../../../functionalComponents/dataFormatFunctions';
import moment from 'moment';

// Custom styles using makeStyles
const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(1),
    borderRadius: '8px',
    marginBottom: theme.spacing(4),
  },
  label: {
    fontWeight: 'bold',
  },
  value: {
    marginTop: theme.spacing(1),
  },
}));

const BatchDetailsStepper = (props) => {
    const classes = useStyles();
    const { data } = props;
  return (
    <Box p={2} border={1} borderColor="grey.300"  style={{ backgroundColor: '#f9f9f9',marginTop:'2rem' }}>
      <Grid container spacing={4} style={{padding:'2rem'}}>
              
              <Grid container spacing={3} item xs={12}>
                  {/* Produced Quantity */}
              <Grid item xs={12} sm={3}>
          <Typography className={classes.label}>Produced Quantity</Typography>
                      <Typography className={classes.value}>{presentFormatedData(data.producedQuantity)}</Typography>
        </Grid>

        {/* Units of Measurement (UOM) */}
        <Grid item xs={12} sm={3}>
          <Typography className={classes.label}>Units of Measurement (UoM)</Typography>
          <Typography className={classes.value}>{presentFormatedData(data.uom)}</Typography>
        </Grid>
              </Grid>
        

              <Grid container spacing={3} item xs={12}>
        {/* Storage Location */}
        <Grid item xs={12} sm={3}>
          <Typography className={classes.label}>Storage Location</Typography>
          <Typography className={classes.value}>{presentFormatedData(data.storageLocationName)}</Typography>
        </Grid>

        {/* Storage Condition */}
        <Grid item xs={12} sm={3}>
          <Typography className={classes.label}>Storage Condition</Typography>
          <Typography className={classes.value}>{presentFormatedData(data.storageCondition)}</Typography>
        </Grid>

        {/* Expiry Date */}
        <Grid item xs={12} sm={3}>
          <Typography className={classes.label}>Expiry Date</Typography>
          <Typography className={classes.value}>{data?.expiryDate ? moment(data.expiryDate).format('DD-MMM-YYYY'):'-NA-'}</Typography>
                  </Grid>
                  
                  </Grid>
      </Grid>
    </Box>
  )
}

export default BatchDetailsStepper